import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const RemediationConsole = ({ recommendation }) => {
  const { t } = useTranslation();
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = () => {
    if (recommendation && recommendation.remediation_script) {
      navigator.clipboard.writeText(recommendation.remediation_script);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
    }
  };

  const consoleWrapperStyle = {
    background: 'rgba(15, 23, 42, 0.65)',
    border: '1px solid rgba(79, 70, 229, 0.28)',
    borderRadius: '16px',
    padding: '24px',
    marginBottom: '30px',
    backdropFilter: 'blur(14px)',
    WebkitBackdropFilter: 'blur(14px)',
    boxShadow: '0 8px 32px rgba(0,0,0,0.35)',
  };

  const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '15px',
    borderBottom: '1px solid var(--glass-border)',
    paddingBottom: '10px'
  };

  const terminalStyle = {
    background: '#090D16',
    border: '1px solid #1E293B',
    borderRadius: '10px',
    padding: '20px',
    overflowX: 'auto',
    position: 'relative',
    fontFamily: "'Courier New', Courier, monospace",
    color: '#38BDF8', // Light blue terminal text
    fontSize: '0.85rem',
    lineHeight: '1.5',
    minHeight: '150px',
    maxHeight: '400px',
    textAlign: 'left',
    boxShadow: 'inset 0 2px 8px rgba(0,0,0,0.8)'
  };

  const placeholderStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'var(--text-secondary)',
    height: '100%',
    minHeight: '110px',
    textAlign: 'center',
    fontSize: '0.9rem',
    fontStyle: 'italic'
  };

  return (
    <div style={consoleWrapperStyle}>
      <div style={headerStyle}>
        <h3 style={{ margin: 0, fontSize: '1.15rem', fontWeight: '700', color: '#E2E8F0', display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
          <span>💻</span> {t('finops.remediation_title')}
          {recommendation && recommendation.carbon_reduction_potential_gco2e > 0 && (
            <span className="inline-flex items-center gap-1 bg-green-950/40 text-green-400 border border-green-500/30 px-2.5 py-0.5 rounded-full text-[10px] font-bold">
              🍃 {recommendation.carbon_reduction_potential_gco2e.toFixed(1)} gCO2e
            </span>
          )}
          {recommendation && recommendation.energy_reduction_potential_kwh > 0 && (
            <span className="inline-flex items-center gap-1 bg-emerald-950/40 text-emerald-400 border border-emerald-500/30 px-2.5 py-0.5 rounded-full text-[10px] font-bold">
              ⚡ {recommendation.energy_reduction_potential_kwh.toFixed(2)} kWh
            </span>
          )}
        </h3>
        {recommendation && recommendation.remediation_script && (
          <button
            onClick={copyToClipboard}
            className="btn-primary"
            style={{
              padding: '6px 14px',
              fontSize: '0.8rem',
              borderRadius: '6px',
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              boxShadow: '0 4px 6px rgba(79, 70, 229, 0.15)'
            }}
          >
            {isCopied ? (
              <>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6L9 17l-5-5"/></svg>
                {t('finops.remediation_copied')}
              </>
            ) : (
              <>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><rect x="9" y="9" width="13" height="13" rx="2" ry="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
                {t('finops.remediation_copy')}
              </>
            )}
          </button>
        )}
      </div>

      <div style={terminalStyle}>
        {recommendation && recommendation.remediation_script ? (
          <pre style={{ margin: 0, fontFamily: 'inherit', color: '#38BDF8', whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
            {recommendation.remediation_script}
          </pre>
        ) : (
          <div style={placeholderStyle}>
            {t('finops.remediation_select_placeholder')}
          </div>
        )}
      </div>
    </div>
  );
};

export default RemediationConsole;
